<template>
  <div style="height: 100%">
    <BaseContainer style="height:100%" class="one_table">
      <TableMain name="one table" ref="SalesOrderItemsTable1" :fields="fields" :title="table_title.title1"
        :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
        :show_date_picker="true" :show_toolbar="true" :show_filter="true" :date_picker_label="date_picker_label"
        :query_button_label="query_lable" :show_toolbar_state="true" :isBusy="isBusy"
        :hb_table_class="'hb_table_so_items_class1'" :table_height_adjust="-8" :loading_width="40"
        :show_toolbar_button="[0, 0, 0, 0, 0, 1, 1]" @on_query="on_query" @state_change="state_change"
        @tool_invoke="tool_invoke" :show_to_sale="true" tableref="f169edb576dd43ef90effc81320d0b6e">
        <template #query>
          {{ $t("common.label_forecast_order_num") }}：<el-input clearable size="small" style="width: 150px"
            v-model="ForecastSalesId"></el-input>
          {{ $t("common.customer") + $t("common.account") }}：<el-input clearable size="small" style="width: 150px"
            v-model="CustAccountId">
          </el-input>
          {{ $t("common.customer") + $t("common.name") }}：<el-input clearable size="small" style="width: 200px"
            v-model="CustAccountName"></el-input>
        </template>
        <template #toolbar>
          <el-checkbox :label="$t('common.only_uncancel')" v-model="onlyNotCancel" class="ml-2"
            @change="notCancel"></el-checkbox>
        </template>
      </TableMain>
    </BaseContainer>
    <BaseModal ref="bvSaleModal" :title="$t('common.toSaleOrder')" @saveData="saveToSaleOrder">
      <template #modal_content>
        <el-form :model="dataSaleForm" :rules="SaleRules" ref="dataSaleForm" label-width="100px" class="demo-dataForm"
          style="height: 200px">
          <el-col :span="12">
            <el-form-item :label="$t('common.order_pool')" prop="SalesPoolId">
              <el-select size="small" v-model="dataSaleForm.SalesPoolId" filterable clearable
                :placeholder="$t('common.order_pool')" class="w-100">
                <el-option v-for="item in getBaseDataSOPool(dataSaleForm.dataAreaId)" :key="item.SalesPoolId"
                  :label="item.SalesPoolId" :value="item.SalesPoolId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item :label="$t('common.delivery_date')" prop="DeliveryDate">
              <el-date-picker size="small" type="date" :placeholder="$t('common.delivery_date')"
                v-model="dataSaleForm.DeliveryDate" style="width: 100%">
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item :label="$t('common.description')" prop="TEC_Remark">
              <el-input type="textarea" rows="3" v-model="dataSaleForm.TEC_Remark"></el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </template>
    </BaseModal>
  </div>
</template>

<script>
// -- import * as _ from "lodash-es"
import * as commonController from "../../controllers/commonController"
import * as OrderForecastDispatchSearchController from "../../controllers/sd/OrderForecastDispatchSearchController"
import * as OrderForecastItemsController from "../../controllers/sd/OrderForecastItemsController"
import * as SalesOrderController from "../../controllers/sd/SalesOrderController"
import * as SalesOrderExportController from "../../controllers/sd/SalesOrderExportController"
import BaseContainer from "../components/BaseContainer"
import BaseModal from "../components/modals/baseModal"
import TableMain from "../components/table/TableMain"

export default {
  name: "OrderForecastItems",
  components: {
    BaseContainer,
    TableMain,
    BaseModal,
  },
  data() {
    return {
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_forecast_detail",
      },
      fields: OrderForecastItemsController.fields.default,

      CustAccountName: "",
      CustAccountId: "",
      ForecastSalesId: "",
      isBusy: false,
      all_role_users: [],
      onlyNotCancel: false,
      his_order_list: [],
      dataSaleForm: _.cloneDeep(SalesOrderController.dataForm), //转单modal
      SaleRules: SalesOrderController.rules,
      OrderForecastLine: [],
    }
  },
  created() {
    this.getAllRoleUsers()
  },
  methods: {
    ///获取订单池
    getBaseDataSOPool(_dataAreaId) {
      if (!_.isEmpty(_dataAreaId)) {
        return _.filter(this.$store.state.biz_data.baseData.SalesPool, {
          dataAreaId: _dataAreaId,
        })
      }
      return []
    },
    //转换
    async saveToSaleOrder(cb) {
      let _this = this
      let _data = _.cloneDeep(_this.dataSaleForm)
      if (_data.SalesPoolId == "" || _.isNull(_data.SalesPoolId)) {
        _this.msgToasts(this.$t("notify.not_sales_pool"), "info")
        cb(null)
        return
      }
      if (_data.DeliveryDate == "" || _.isNull(_data.DeliveryDate)) {
        _this.msgToasts(this.$t("notify.not_delivery_date"), "info")
        cb(null)
        return
      }
      this.$refs.dataSaleForm.validate(async (valid) => {
        if (valid) {
          let _data = _.cloneDeep(_this.dataSaleForm)
          _data.DeliveryDate = this.$date.format(
            new Date(_data.DeliveryDate),
            "yyyy-MM-dd"
          )

          ///新建时检查日期是否超过当前服务器日期
          let _is_date_ok =
            await commonController.methods.checkIsBeforeCurrentDate(
              _data.DeliveryDate
            )
          if (!_is_date_ok && _data.id == "") {
            _this.msgToasts(this.$t("notify.delivery_date_not_more_current_date"), "info")
            cb(null)
            return
          }
          let _bool = true
          _.each(this.OrderForecastLine, (t) => {
            if (t.SalesQty < 0) {
              _bool = false
            }
          })
          if (!_bool) {
            this.msgToasts(this.$t("notify.not_minus_pcs"), "error")
            cb(false)
            return
          }
          //调用订单导入接口

          let data = { username: this.$global.global_data.local_username }
          let items = []
          _.each(this.OrderForecastLine, (t) => {
            let item = {}
            item.AccountNum = _data.CustAccount
            item.dataAreaId = _data.dataAreaId
            item.ItemId = t.ItemId
            item.VariantName = t.VariantName
            item.DeliveryDate = _data.DeliveryDate
            item.SalesQty = t.SalesQty
            item.SalesPoolId = _data.SalesPoolId
            item.TEC_OtherInfo = ""
            item.TEC_CommonRemark = _data.TEC_Remark
            item.SEI_PriceUnitCust = 0
            item.SEI_OrderDateCust = this.$date.format(
              new Date(),
              "yyyy-MM-dd"
            )
            item.SEI_OrderDateCust = _data.DeliveryDate
            items.push(item)
          })
          data.data = items

          let _gt_credit =
            await SalesOrderExportController.methods.pickAndInvoke([
              _data.dataAreaId,
            ])
          if (_gt_credit) {
            if (_gt_credit.status != 0) {
              _this.msgToasts(this.$t("notify.ax_error") + "：" + _gt_credit.message, "error")
              cb(false)
              return
            }
          } else {
            _this.msgToasts(this.$t("notify.ax_call_failed"), "error")
            cb(false)
            return
          }
          let result =
            await SalesOrderExportController.methods.SaveSaleOrderExport(
              JSON.stringify(data)
            )
          if (result[0][0].status == 0) {
            this.msgToasts(this.$t("notify.import_success"), "success")
            cb(true, true)
          } else {
            let str = "<div><strong>" + this.$t("notify.transfer_unseccess") + ":</strong></div>"
            _.each(result[0], (t) => {
              if (
                _.isNull(t.companyName) ||
                _.isNull(t.customerName) ||
                _.isNull(t.dataAreaId) ||
                t.dataAreaId == "" ||
                _.isNull(t.variantId) ||
                _.isNull(t.SalesPool) ||
                t.existsRetailVariantId == 0
              ) {
                str += this.ErrorMsg(t)
              }
            })
            this.msgToasts(str, "error", 0, true, "notify550")
            cb(false)
            return
          }
        } else {
          this.dataSaleForm.DeliveryDate = new Date()
          cb(false)
          return false
        }
      })
    },
    ErrorMsg(data) {
      if (_.isNull(data.variantId)) {
        return ("<div>" + this.$t("common.customer") + ":" + "<strong>" + data.AccountNum + "</strong>" + "，" + this.$t("common.invent") + this.$t("common.num") + ":" + "<strong>" + data.ItemId + "</strong>" + "，<strong>" + this.$t("common.variant_coding") + "</strong>" + this.$t("common.not_exist") + "</div>")
      }
      if (_.isNull(data.customerName)) {
        return ("<div>" + this.$t("common.customer") + ":" + "<strong>" + data.AccountNum + "</strong>" + "，" + this.$t("common.invent") + this.$t("common.num") + ":" + "<strong>" + data.ItemId + "</strong>" + "，<strong>" + this.$t("common.customer") + "</strong>" + this.$t("common.not_exist") + "</div>")
      }
      if (_.isNull(data.companyName)) {
        return ("<div>" + this.$t("common.customer") + ":" + "<strong>" + data.AccountNum + "</strong>" + "，" + this.$t("common.invent") + this.$t("common.num") + ":" + "<strong>" + data.ItemId + "</strong>" + "，<strong>" + this.$t("common.company") + "</strong>" + this.$t("common.not_exist") + "</div>")
      }
      if (_.isNull(data.SalesPool)) {
        return ("<div>" + this.$t("common.customer") + ":" + "<strong>" + data.AccountNum + "</strong>" + "，" + this.$t("common.invent") + this.$t("common.num") + ":" + "<strong>" + data.ItemId + "</strong>" + "，<strong>" + this.$t("common.sales_pool") + "</strong>" + this.$t("common.not_exist") + "</div>")
      }
      if (data.existsRetailVariantId == 0) {
        return ("<div>" + this.$t("common.customer") + ":" + "<strong>" + data.AccountNum + "</strong>" + "，" + this.$t("common.invent") + this.$t("common.num") + ":" + "<strong>" + data.ItemId + "</strong>" + "，<strong>" + this.$t("common.invent") + "</strong>" + this.$t("common.not_exist") + "</div>")
      }
      return ""
    },
    async getAllRoleUsers() {
      let _result = await SalesOrderController.methods.getAllRoleUserName()
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.all_role_users = _result[0]
      }
    },
    //#region 查询
    async on_query(set_data, date_range) {
      this.isBusy = true
      let _fromDate = "",
        _toDate = ""
      let _params = {}
      if (this.CustAccountName != "") {
        _params.CustAccountName = this.CustAccountName
      }
      if (this.CustAccountId != "") {
        _params.CustAccountId = this.CustAccountId
      }
      if (this.ForecastSalesId != "") {
        _params.ForecastSalesId = this.ForecastSalesId
      }
      if (
        !_.isNull(date_range) &&
        this.CustAccountId == "" &&
        this.ForecastSalesId == "" &&
        this.CustAccountName == ""
      ) {
        _fromDate = this.$date.format(date_range[0], "yyyy-MM-dd")
        _toDate = this.$date.format(date_range[1], "yyyy-MM-dd")
        _params["fromDate"] = _fromDate
        _params["toDate"] = _toDate
      }
      set_data([])
      let _result = await OrderForecastItemsController.methods.getData(_params)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        // _.each(_result[0], (t) => {
        //   this.getApprover(t);
        // });
        this.his_order_list = _result[0]
        set_data(_.orderBy(_result[0], ["createdDateTime"], ["desc"]))
      }
      this.isBusy = false
    },
    getApprover(t) {
      commonController.methods.getUserNameFromRole(
        this.all_role_users,
        t,
        "fcGetSFApprover",
        "SFApprover",
        t.fcCheckSFApproved
      )
    },
    //#endregion

    //#region 状态切换
    state_change(data, cb) {
      if (data.selected_items.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        cb(false)
        return
      }
      if (data.state === "cancel" || data.state === "uncancel") {
        let is_my_data = true
        _.each(data.selected_items, (t) => {
          if (
            t.create_by &&
            t.create_by != this.$store.state.biz_data.userInfo.user_id
          ) {
            is_my_data = false
          }
        })
        if (!is_my_data) {
          this.msgToasts(this.$t("notify.not_created_by_yourself"))
          cb(false)
          return
        }

        ///取消，反取消
        let _state = data.state == "cancel" ? true : false
        let _msg = data.state == "cancel" ? "取消" : "反取消"

        this.msgModal(this.$t("notify.is_continue")).then(async (v) => {
          if (v) {
            const loading = this.$loading({
              lock: true,
              text: this.$t("notify.saveing"),
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)",
            })

            let res_msg = []
            let isValid = _state ? 1 : 0
            let select_list = _.cloneDeep(data.selected_items)
            ///获取所有预测明细派单
            let sfld_list = await this.getSLFDItems(select_list)
            console.log(sfld_list)
            for (var i in select_list) {
              let _list = []
              _list.push(select_list[i])

              ///整理ax参数
              let ax_list = _.filter(sfld_list, function (t) {
                if (
                  t.OrderForecast_Line_id == select_list[i].forecast_line_id
                ) {
                  t.ForecastSalesId = select_list[i].ForecastSalesId
                  t.CustAccountId = select_list[i].CustAccountId
                  return t
                }
              })

              let ax_params = this.getAXParams(ax_list, isValid)

              ///修改明细取消
              let update_params = []
              update_params.push({
                id: select_list[i].forecast_line_id,
                is_cancel: isValid,
              })

              let _params = {
                update_data: update_params,
                ax_params: ax_params,
              }
              // loading.close()
              // console.log(_params)
              let result =
                await OrderForecastItemsController.methods.cancelData(_params, this)
              if (!_.isNull(result)) {
                if (result.state == true) {
                  ///成功
                  _.each(_params.update_data, (t) => {
                    let m = _.find(data.selected_items, {
                      forecast_line_id: t.id,
                    })
                    if (m) {
                      m.is_cancel = _state
                    }
                  })
                } else {
                  res_msg.push("<hr/><div>" + result.message + "</div>")
                }
              }
            }

            if (res_msg.length == 0) {
              this.msgToasts(this.$t("notify.action_successfully"), "success")
              cb(true)
            } else {
              this.msgToasts(_.join(res_msg, " "), "info", null, true)
              cb(false)
            }

            loading.close()
          }
        })
      } else if (data.state === "toSaleOrder") {
        //检查是否为同一dataAreaId  同一个客户 同一个装运日期

        let _company = _.groupBy(data.selected_items, "dataAreaId")
        let custmer = _.groupBy(data.selected_items, "CustAccountId")

        let i = 0,
          j = 0
        _.each(_company, (t) => {
          i++
        })
        _.each(custmer, (t) => {
          j++
        })
        console.log(i)
        console.log(j)
        if (i > 1 || j > 1) {
          this.msgToasts(this.$t("notify.must_be_same_company_customer"), "warning")
          cb(false)
          return
        }
        let _index = _.findIndex(data.selected_items, {
          fcCheckSFApproved: false,
        })
        if (_index > -1) {
          this.msgToasts(this.$t("notify.must_selected_unapproved"), "warning")
          cb(false)
          return
        }
        this.dataSaleForm.CustAccount = data.selected_items[0].CustAccountId
        this.dataSaleForm.dataAreaId = data.selected_items[0].dataAreaId
        this.dataSaleForm.InvoiceAccount = this.dataSaleForm.CustAccount
        this.dataSaleForm.TEC_FinalCustAccount = this.dataSaleForm.CustAccount
        this.OrderForecastLine = data.selected_items
        this.$refs.bvSaleModal.show()
      }
    },
    async getSLFDItems(list) {
      let _list = []
      for (var i in list) {
        let _result =
          await OrderForecastDispatchSearchController.methods.getDispatchItems({
            OrderForecast_Line_id: { "=": list[i].forecast_line_id },
            is_deleted: { "=": 0 },
          })
        if (!_.isNull(_result) && _result && _result.length > 0) {
          let hasToAX = _.filter(_result[0], (t) => {
            return t.AXId != "" && !_.isNull(t.AXId)
          })
          _list = _.union(_list, hasToAX)
        }
      }
      return _list
    },
    ///AX接口参数
    getAXParams(_list, _isVlid) {
      let _this = this
      let sf_line = _list[0]
      let _ax_params = []
      for (var i in _list) {
        let t = _list[i]
        ///整理jsonData
        let _jsonData = []
        _jsonData.push({
          ItemId: sf_line.ItemId,
          RetailVariantId: t.RetailVariantId,
          StartDate: _this.formatDate(t.delivery_date),
          EndDate: "",
          Active: "Yes",
          IsCancel: _isVlid,
          CustAccountId: sf_line.CustAccountId,
          CurrencyCode: "CNY",
          orderId: sf_line.ForecastSalesId, ///订单编号
          createdBy: sf_line.create_by_username,
          SalesQty: t.qty,
          SalesUnitId:
            _.isEmpty(sf_line.SalesUnitId) == true ? "个" : sf_line.SalesUnitId,
          ModelId: t.ModelId,
          Status: "Update",
          AXId: t.AXId,
        })
        let _company = _.find(
          _this.$store.state.biz_data.baseData.CompanyInfo,
          { VenderAccountNum: t.AccountNum }
        )

        if (_company) {
          _ax_params.push({
            company: _company.DataArea,
            dic_id: t.id,
            jsonData: _jsonData,
          })
        }
      }

      return _ax_params
    },

    //#endregion

    //#region 打印导出
    tool_invoke(data, cb) {
      if (data.tool == "adhoc_report") {
        let _data = {
          state: true,
          fields: this.fields,
          title: "table_sales_order_detail",
          sheet_title: "客户",
        }
        ///调用公用导出(如果调用特定导出则可以写在这里)
        cb(_data)
      } else {
        ///调用公用打印(如果调用特定打印则可以写在这里)
        // cb(_data);
      }
    },
    //#endregion
    notCancel() {
      if (this.his_order_list.length == 0) {
        this.onlyNotCancel = false
        this.msgToasts(this.$t("notify.excute_search_before"), "info")
        return
      }
      if (this.onlyNotCancel) {
        let _list = _.filter(this.$refs.SalesOrderItemsTable1.my_data, {
          is_cancel: false,
        })
        this.$refs.SalesOrderItemsTable1.SetData(_list)
      } else {
        this.$refs.SalesOrderItemsTable1.SetData(this.his_order_list)
      }
    },
  },
}
</script>
<style>
.hb_table_so_items_class1 {
  /* width: auto; */
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 300rem;
}
</style>
